import React, { useState, useEffect } from 'react'
import './NotificationPopupStyles.css';
import { useSpring, animated } from 'react-spring';

export default function NotificationPopup(props) {
    const animatedStyle = useSpring({
        from: { transform: 'translateY(100%)' },
        to: { transform: 'translateY(0%)' },
        config: { duration: 300 }, // Duration in milliseconds
      });
    const { requestNotification, reomveNotificationPopup, notificationDenied, notificationPermissionStatus } = props;
    const [permission, setPermission] = useState(Notification.permission);
    useEffect(() => {
        setTimeout(() => {
            reomveNotificationPopup()
        }, 50000);
        return()=>{
            reomveNotificationPopup();
        }
    },[])
    useEffect(() => {
        setPermission(notificationPermissionStatus);    
    }, [props]);
    return (
        <animated.div style={animatedStyle} >
            <div className='divider-notif-popup'></div>
            {permission === "denied" ? <div className='notification-popup-container' >
                <span>Looks like you have denied the permission from browser. Please change the perissions manually</span>

                <button onClick={reomveNotificationPopup}>Okay</button>
            </div> : <div className='notification-popup-container' >
                <span>Don't missout on any replies! Allow push notifications?</span>
                <button onClick={requestNotification}>Yes</button>
                <button onClick={reomveNotificationPopup}>No</button>
            </div>}
        </animated.div >

    )
}
